import { supabase } from '../supabaseClient';

// Note: "Head Admin" does not exist in the Supabase database schema or API.
// The sole administrative RPC function is check_is_admin(p_email).
// Legacy head admin flags are cleaned up on load to avoid stale localStorage entries.
const cleanLegacyHeadAdmin = () => {
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.removeItem('isHeadAdmin');
    } catch {
      // Ignore storage errors
    }
  }
};
cleanLegacyHeadAdmin();

const getStoredHeadAdminFlag = () => false;
const setStoredHeadAdminFlag = () => {};
const clearStoredHeadAdminFlag = () => cleanLegacyHeadAdmin();
const toBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (value == null) return false;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return false;
};

const resolveAdminRole = async (email) => {
  if (!email) {
    return { isAdmin: false, isHeadAdmin: false };
  }

  // SECURITY: Check tbl_admin via secure server-side check_is_admin RPC function.
  try {
    const response = await supabase.rpc('check_is_admin', {
      p_email: String(email).trim(),
    });

    const adminValue = response?.data;
    return { isAdmin: toBoolean(adminValue), isHeadAdmin: false };
  } catch (err) {
    console.warn('Admin check warning:', err);
    return { isAdmin: false, isHeadAdmin: false };
  }
};

const getAdminDisplayLabel = () => 'Admin';

export {
  clearStoredHeadAdminFlag,
  getAdminDisplayLabel,
  getStoredHeadAdminFlag,
  resolveAdminRole,
  setStoredHeadAdminFlag,
};